function createElementFromString(htmlString) {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()

  return div.children
}

export default createElementFromString
